import { LogoJsonLd } from 'next-seo';

import APP from 'constants/app';

function LogoSchema() {
  return (
    <LogoJsonLd
      logo={`${APP.URL}${APP.LOCAL_IMAGE_PATH}/features/topbar/promobit-logo.svg`}
      url={APP.URL}
    />
  );
}

export default LogoSchema;
